import { render } from "./ListeRolePage.vue?vue&type=template&id=27f21178&ts=true"
import script from "./ListeRolePage.vue?vue&type=script&lang=ts"
export * from "./ListeRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__